import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { VerifyIpAddressComponent } from './verify-ip-address/verify-ip-address.component';
import { RegisterComponent } from './register/register.component';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { RouterModule } from '@angular/router';
import { GeneralModule } from '../general/general.module';
import { ReactiveFormsModule } from '@angular/forms';
import { NoWalletComponent } from './no-wallet/no-wallet.component';
import { RegisterMarketerComponent } from './register-marketer/register-marketer.component';
import { MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    GeneralModule,
    ReactiveFormsModule,
    MatCheckboxModule
  ],
  declarations: [
    ForgotPasswordComponent,
    ResetPasswordComponent,
    VerifyIpAddressComponent,
    RegisterComponent,
    LoginComponent,
    LogoutComponent,
    NoWalletComponent,
    RegisterMarketerComponent
  ],
  exports: [
    ForgotPasswordComponent,
    ResetPasswordComponent,
    VerifyIpAddressComponent,
    RegisterComponent,
    LoginComponent,
    LogoutComponent,
    NoWalletComponent,
    RegisterMarketerComponent
  ]
})
export class AuthComponentsModule { }
